import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { UserProfileService } from '../../services/user-profile.service';
import * as UserProfileActions from './userProfile.actions';

@Injectable()
export class UserProfileEffects {

  submitUserProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserProfileActions.submitUserProfile),
      tap(() => console.log('User Profile effect triggered')),
      switchMap(action =>
        this.userProfileService.submitUserProfile(action.profileData).pipe(
          tap(() => console.log('Calling user profile service', action.profileData)),
          map(response => {
            if (!response || !response.data) {
              throw new Error('Invalid user profile response');
            }
            console.log('User profile submission successful', response.data);
            return UserProfileActions.submitUserProfileSuccess({ response: response.data });
          }),
          catchError(error => {
            console.log('User profile submission failed', error);
            return of(UserProfileActions.submitUserProfileFailure({ error }));
          })
        )
      )
    )
  );

  fetchUserProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserProfileActions.fetchUserProfile),
      switchMap(() =>
        this.userProfileService.getUserProfile().pipe(
          map(data => UserProfileActions.fetchUserProfileSuccess({ data })),
          catchError(error => of(UserProfileActions.fetchUserProfileFailure({ error })))
        )
      )
    )
  );

  updateUserProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserProfileActions.updateUserProfile), // Listening for the update action
      tap(() => console.log('User Profile update effect triggered')),
      switchMap(action =>
        this.userProfileService.updateUserProfile(action.id, action.profileData).pipe(
          tap(() => console.log('Calling user profile update service', action.profileData)),
          map(response => {
            if (!response || !response.data) {
              throw new Error('Invalid user profile update response');
            }
            console.log('User profile update successful', response.data);
            return UserProfileActions.updateUserProfileSuccess({ profile: response.data });
          }),
          catchError(error => {
            console.log('User profile update failed', error);
            return of(UserProfileActions.updateUserProfileFailure({ error }));
          })
        )
      )
    )
  );

  skipSetup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserProfileActions.skipSetup),
      tap(() => console.log('Skip Setup effect triggered')),
      switchMap(() =>
        this.userProfileService.skipSetup().pipe(
          tap(() => console.log('Calling setup service to skip setup')),
          map(response => {
            // Assuming the response only returns a message field
            console.log('Setup skip successful', response.message);
            return UserProfileActions.skipSetupSuccess({ message: response.message });
          }),
          catchError(error => {
            console.log('Setup skip failed', error);
            return of(UserProfileActions.skipSetupFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private userProfileService: UserProfileService
  ) {}
}
